import { TableColumn } from "../../types";
import { InternalLink } from "../../components/InternalLink";

const nameDefault = { id: "name", label: "Name" };
export function NameColumn<TData extends { name: string; kind: string; selfLink: string }>(
  column: Partial<TableColumn<TData>> = nameDefault,
  options?: {
    shouldForceTargetBlank?: (item: TData) => boolean;
  },
) {
  const preset: TableColumn<TData> = {
    ...nameDefault,
    enableResize: true,
    enableSort: false,
    size: 200,
    cell: (p) => {
      const item = p.row.original;

      let shouldForceTargetBlank = false;
      if (options && options.shouldForceTargetBlank) {
        shouldForceTargetBlank = options.shouldForceTargetBlank(item);
      }

      return (
        <div className="flex flex-col justify-center" style={{ height: 56 }}>
          <InternalLink label={item.name} to={`/console${item.selfLink}`} forceTargetBlank={shouldForceTargetBlank} />
        </div>
      );
    },
  };
  return Object.assign(preset, column);
}
